const defaultState = {
    rules: [],
    rule: {},
    loading: false,
    errors:{}
  }
  
export default (state=defaultState, action={}) => {
    switch (action.type) {
      case 'FETCH_RULES_FULFILLED': {
        return {
          ...state,
          rules: action.payload.data,
          loading: false,
          errors: {}
        }
      }
  
      case 'FETCH_RULES_PENDING': {
        return {
          ...state,
          loading: true,
          errors: {}
        }
      }
  
      case 'FETCH_RULES_REJECTED': {
        return {
          ...state,
          loading: false,
          errors: { global: action.payload.message }
        }
      }
      
      case 'NEW_RULE': {
        return {
          ...state,
          rule: {}
        }
      }
  
      case 'SAVE_RULE_PENDING': {
        return {
          ...state,
          loading: true
        }
      }
  
      case 'SAVE_RULE_FULFILLED': {
        return {
          ...state,
          rules: [...state.rules, action.payload.data],
          errors: {},
          loading: false
        }
      }
  
      case 'SAVE_RULE_REJECTED': {
        const data = action.payload.response.data;
        // convert feathers error formatting to match client-side error formatting   
        const { RULE_CODE, RULE_VALUE, RULE_DESC } = data.errors;
        const errors = { global: data.message, RULE_CODE, RULE_VALUE, RULE_DESC };
        return {
          ...state,
          errors: errors,
          loading: false
        }
      }
  
      case 'FETCH_RULE_PENDING': {
        return {
          ...state,
          loading: true,
          rule: {}
        }
      }
  
      case 'FETCH_RULE_FULFILLED': {
        return {
          ...state,
          rule: action.payload.data[0],
          errors: {},
          loading: false
        }
      }
  
      case 'UPDATE_RULE_PENDING': {
        return {
          ...state,
          loading: true
        }
      }
  
      case 'UPDATE_RULE_FULFILLED': {
        const rule = action.payload.data;
        return {
          ...state,
          rules: state.rules.map(item => item.ID === rule.ID ? rule : item),
          errors: {},
          loading: false
        }
      }
  
      case 'UPDATE_RULE_REJECTED': {
        const data = action.payload.response.data;
        const { RULE_CODE, RULE_VALUE, RULE_DESC } = data.errors;
        const errors = { global: data.message, RULE_CODE, RULE_VALUE, RULE_DESC };
        return {
          ...state,
          errors: errors,
          loading: false
        }
      }
  
      case 'DELETE_RULE_FULFILLED': {
        const id = parseInt(action.payload.data.ID, 10);
        return {
          ...state,
          rules: state.rules.filter(item => item.ID !== id)
        }
      }
  
      default:
        return state;
    }
  }



// WEBPACK FOOTER //
// ./src/reducers/rules-reducer.js